import { render, staticRenderFns } from "./proxyModuleList.vue?vue&type=template&id=55f6aa8a&scoped=true"
import script from "./proxyModuleList.vue?vue&type=script&lang=js"
export * from "./proxyModuleList.vue?vue&type=script&lang=js"
import style0 from "./proxyModuleList.vue?vue&type=style&index=0&id=55f6aa8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f6aa8a",
  null
  
)

export default component.exports